import React, { useState } from "react";
import DeleteConfirmModal from "./DeleteConfirmModal";

export default function SMRTDocsNotifyModal({
  isOpen,
  onClose,
  title,
  data,
  onSave,
}: any) {
  const [expiryDate, setExpiryDate] = useState(data?.expiryDate || "");
  const [days, setDays] = useState("");
  const [toMe, setToMe] = useState(false);
  const [toClient, setToClient] = useState(false);
  const [reminders, setReminders] = useState<any[]>(data?.reminders || []);
  const [deleteConfirm, setDeleteConfirm] = useState<{ index: number } | null>(null);

  if (!isOpen) return null;

  return (
    <div className="smrtdocs-modal-overlay">
      <div className="smrtdocs-modal">
        <div className="smrtdocs-modal-header">
          <h2>
            {title ? `${title} - Document Reminder` : "Document Reminder"}
          </h2>
        </div>

        <div className="smrtdocs-modal-body">
          <div
            style={{
              marginBottom: "16px",
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <div>Please set Document Expiry Date</div>
            <input
              type="date"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
            />
          </div>

          <div
            style={{
              border: "1px solid #ccc",
              padding: "16px",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "80px 60px 80px 60px",
                gap: "12px",
                marginBottom: "8px",
                alignItems: "center",
              }}
            >
              <div>Days</div>
              <div>Me</div>
              <div>Client</div>
              <div>Actions</div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "80px 60px 80px 60px",
                gap: "12px",
                marginBottom: "12px",
              }}
            >
              <input
                value={days}
                onChange={(e) => setDays(e.target.value)}
                placeholder="e.g. 90"
                style={{ width: "80px" }}
              />

              <input
                type="checkbox"
                checked={toMe}
                onChange={(e) => setToMe(e.target.checked)}
              />

              <input
                type="checkbox"
                checked={toClient}
                onChange={(e) => setToClient(e.target.checked)}
              />

              <div style={{ display: "flex", gap: "6px" }}>
                {/* ADD */}
                <button
                  className="btn-icon smrtdocs-btn-issue"
                  title="Add reminder"
                  onClick={() => {
                    if (!days) return;
                    if (!toMe && !toClient) return;

                    setReminders([...reminders, { days, toMe, toClient }]);

                    setDays("");
                    setToMe(false);
                    setToClient(false);
                  }}
                >
                  <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                    +
                  </span>
                </button>
              </div>
            </div>

            {reminders.map((r, i) => (
              <div
                key={i}
                style={{
                  display: "grid",
                  gridTemplateColumns: "80px 60px 80px 60px",
                  gap: "12px",
                  marginBottom: "6px",
                  cursor: "pointer",
                  padding: "6px",
                  borderRadius: "6px",
                  alignItems: "center",
                }}
              >
                <div>{r.days} days</div>
                <div>{r.toMe ? "✔" : ""}</div>
                <div>{r.toClient ? "✔" : ""}</div>

                <div style={{ display: "flex", gap: "6px" }}>
                  {/* DELETE */}
                  <button
                    className="btn-icon btn-toggle-delete"
                    title="Delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteConfirm({ index: i });
                    }}
                  >
                    🗑
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button className="btn-cancel" onClick={onClose}>
              Cancel
            </button>

            <button
              className="btn-save"
              disabled={reminders.length > 0 && !expiryDate}
              onClick={() => {
                onSave({
                  expiryDate,
                  reminders,
                });
                onClose();
              }}
            >
              Update
            </button>
          </div>
        </div>
      </div>
      <DeleteConfirmModal
        isOpen={!!deleteConfirm}
        onClose={() => setDeleteConfirm(null)}
        onConfirm={() => {
          if (deleteConfirm) {
            const updated = [...reminders];
            updated.splice(deleteConfirm.index, 1);
            setReminders(updated);
          }
          setDeleteConfirm(null);
        }}
        title="Delete Notice"
        message="Are you sure you want to delete this notice?"
      />
    </div>
  );
}
